"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncRoundRobin = asyncRoundRobin;
exports.default = void 0;

var _asyncIterable = require("../../internal/async-iterable");

var _asyncInterleave = require("../$interleave/async-interleave");

async function* asyncByPosition({
  start,
  step
}, canTakeAny, ...buffers) {
  start = start % buffers.length;

  for (let i = start; await canTakeAny(); i = (i + step) % buffers.length) {
    if (await buffers[i].canTake()) yield await buffers[i].take();
  }
}

function asyncRoundRobin(sources, start = 0, step = 1) {
  return (0, _asyncInterleave.asyncInterleave)(sources, asyncByPosition, {
    start,
    step
  });
}

var _default = (0, _asyncIterable.asyncIterableCurry)(asyncRoundRobin, {
  variadic: true,
  minArgs: 0,
  maxArgs: 2,

  validateArgs(args) {
    if (args[1] && typeof args[1] === 'object') {
      const {
        start,
        step
      } = args[1];
      args[0] = start != null ? start : 0;
      args[1] = step != null ? start : 1;
    }

    if (args[1] <= 0) {
      throw new Error('step argument to roundRobin must be >= 0');
    }
  }

});

exports.default = _default;